
import api from "@/api";
import { FirmwareUpdate } from "@/api/dtos/FirmwareUpdate.schema";
import { getBase64 } from "@/misc/helpers";
import moment from "moment";
import { Component, Prop, Vue } from "vue-property-decorator";
import CancelButton from "../buttons/CancelButton.vue";
import DangerButton from "../buttons/DangerButton.vue";
import EditFrame from "../EditFrame.vue";
import EditActionButtons from "../EditActionButtons.vue";
import { showToast } from "@/utils/toastService";
import { getAxiosResponse } from "@/utils/errorUtils";

@Component({
  components: {
    EditFrame,
    CancelButton,
    DangerButton,
    EditActionButtons,
  },
})
export default class FirmwareUpdateForm extends Vue {
  @Prop()
  stationUuid!: string;

  uploadDate = new Date();
  firmwareToUpload: File | null = null;
  warningDurationH = 10;

  $refs!: {
    editFrame: EditFrame;
  };
  isEditing = false;

  async onSave(): Promise<void> {
    try {
      await api.StationsApi.enqueueStationFirmwareUpdate(this.stationUuid, {
        firmware: await getBase64(this.firmwareToUpload!),
        start: this.uploadDate.toISOString(),
        warningDuration: moment
          .duration(this.warningDurationH, "hours")
          .toISOString(),
      });

      showToast({
        message: "Firmware-Update erfolgreich geplant",
        type: "success",
      });
    } catch (e) {
      console.error("Firmware update error:", e);

      showToast({
        response: getAxiosResponse(e),
        message: "Firmware-Update konnte nicht geplant werden",
        type: "error",
      });
    }
  }

  onCancel(): void {
    this.uploadDate = new Date();
    this.firmwareToUpload = null;
    this.warningDurationH = 10;
  }
}
